export default (eventType, actType, path, option, card, login, cpId, touchPoint) => {
  return {
    event: eventType, // Dinamic Data
    actionType: actType, // Dynamic Data
    sectionName: path, // Dynamic Data
    loginButton: option, // Dynamic Data
    coBrandedCard: card, // Dynamic Data
    loginType: login, // Dynamic Data
    clubpremierID: cpId, // Dynamic Data
    touchPoint,
  };
};
